import React from 'react';
import { Report } from './Report';
import { useOutletContext } from 'react-router-dom';

export const ReportPage = () => {
  const { termCode, minCrn, isCourseUpdatable } = useOutletContext();
  return <Report termCode={termCode} crn={minCrn} isUpdatable={isCourseUpdatable} />;
};
